import React from "react";
import { Box, LinearProgress, Typography } from "@mui/joy";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../../lib/api";

export const EmailQuotaIndicator: React.FC = () => {
  const { data } = useQuery({
    queryKey: ["email-quota"],
    queryFn: async () => (await api.getEmailQuota()).data,
    staleTime: 60 * 1000,
  });

  if (!data) return null;

  const pct =
    data.limit > 0 ? Math.min((data.used / data.limit) * 100, 100) : 0;
  const color = pct >= 90 ? "danger" : pct >= 80 ? "warning" : "success";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        mb: 1.5,
        flexWrap: { xs: "wrap", sm: "nowrap" },
      }}
    >
      <Typography level="body-xs" fontWeight="lg" sx={{ whiteSpace: "nowrap" }}>
        Monthly email usage
      </Typography>
      <LinearProgress
        determinate
        value={pct}
        color={color}
        sx={{ flex: 1, minWidth: 120, "--LinearProgress-thickness": "6px" }}
      />
      <Typography level="body-xs" color={color} sx={{ whiteSpace: "nowrap" }}>
        {data.used.toLocaleString()} / {data.limit.toLocaleString()} used or
        reserved
        {!!data.reserved && ` (${data.reserved} held)`}
        {" · "}
        {data.remaining.toLocaleString()} left
        {data.remaining <= 0 && " · limit reached"}
      </Typography>
    </Box>
  );
};
